export const DEFAULT_DIAMETER = '100%';
